import _extends from "@babel/runtime/helpers/extends";
import { BannerGroupsInlineStyles } from ".";
import { useBanner } from "../../contexts";
import { isUrl } from "../../utils";

var BannerCookieProperty = function BannerCookieProperty(_ref) {
  var label = _ref.label,
      value = _ref.value,
      children = _ref.children;
  var banner = useBanner();
  var isValueUrl = typeof value === "string" && isUrl(value);
  var useValue = isValueUrl ? h("a", _extends({
    href: value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, BannerGroupsInlineStyles.linkMore(banner, false)), value) : value;
  return h("div", _extends({
    key: label
  }, BannerGroupsInlineStyles.cookieProperty(banner)), h("strong", null, label, ":\xA0"), h("span", {
    style: {
      lineBreak: isValueUrl ? "anywhere" : undefined
    }
  }, useValue), !!children && h("div", null, children));
};

export { BannerCookieProperty };